import { render } from "./OurPricing.vue?vue&type=template&id=c90c7368"
import script from "./OurPricing.vue?vue&type=script&lang=js"
export * from "./OurPricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__